/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityAssetDomainBlocklist } from './ControlEntityAssetDomainBlocklist';
import {
    ControlEntityAssetDomainBlocklistFromJSON,
    ControlEntityAssetDomainBlocklistFromJSONTyped,
    ControlEntityAssetDomainBlocklistToJSON,
} from './ControlEntityAssetDomainBlocklist';
import type { ControlEntityAssetsDomainDnsRecord } from './ControlEntityAssetsDomainDnsRecord';
import {
    ControlEntityAssetsDomainDnsRecordFromJSON,
    ControlEntityAssetsDomainDnsRecordFromJSONTyped,
    ControlEntityAssetsDomainDnsRecordToJSON,
} from './ControlEntityAssetsDomainDnsRecord';
import type { ControlFindingsLevel } from './ControlFindingsLevel';
import {
    ControlFindingsLevelFromJSON,
    ControlFindingsLevelFromJSONTyped,
    ControlFindingsLevelToJSON,
} from './ControlFindingsLevel';

/**
 * 
 * @export
 * @interface ControlEntityAssetsDomainsResult
 */
export interface ControlEntityAssetsDomainsResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    entity_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    source_asset?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityAssetsDomainsResult
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {Array<ControlEntityAssetsDomainDnsRecord>}
     * @memberof ControlEntityAssetsDomainsResult
     */
    dns_records?: Array<ControlEntityAssetsDomainDnsRecord>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    report_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    first_detected?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsDomainsResult
     */
    updated?: string;
    /**
     * 
     * @type {Array<ControlEntityAssetDomainBlocklist>}
     * @memberof ControlEntityAssetsDomainsResult
     */
    blocklists?: Array<ControlEntityAssetDomainBlocklist>;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityAssetsDomainsResult
     */
    findings_count?: number;
    /**
     * 
     * @type {ControlFindingsLevel}
     * @memberof ControlEntityAssetsDomainsResult
     */
    max_level?: ControlFindingsLevel;
}

/**
 * Check if a given object implements the ControlEntityAssetsDomainsResult interface.
 */
export function instanceOfControlEntityAssetsDomainsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityAssetsDomainsResultFromJSON(json: any): ControlEntityAssetsDomainsResult {
    return ControlEntityAssetsDomainsResultFromJSONTyped(json, false);
}

export function ControlEntityAssetsDomainsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetsDomainsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_logo_url': !exists(json, 'entity_logo_url') ? undefined : json['entity_logo_url'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'dns_records': !exists(json, 'dns_records') ? undefined : ((json['dns_records'] as Array<any>).map(ControlEntityAssetsDomainDnsRecordFromJSON)),
        'report_status': !exists(json, 'report_status') ? undefined : json['report_status'],
        'first_detected': !exists(json, 'first_detected') ? undefined : json['first_detected'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'blocklists': !exists(json, 'blocklists') ? undefined : ((json['blocklists'] as Array<any>).map(ControlEntityAssetDomainBlocklistFromJSON)),
        'findings_count': !exists(json, 'findings_count') ? undefined : json['findings_count'],
        'max_level': !exists(json, 'max_level') ? undefined : ControlFindingsLevelFromJSON(json['max_level']),
    };
}

export function ControlEntityAssetsDomainsResultToJSON(value?: ControlEntityAssetsDomainsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_logo_url': value.entity_logo_url,
        'domain': value.domain,
        'source': value.source,
        'source_asset': value.source_asset,
        'ip_addresses': value.ip_addresses,
        'dns_records': value.dns_records === undefined ? undefined : ((value.dns_records as Array<any>).map(ControlEntityAssetsDomainDnsRecordToJSON)),
        'report_status': value.report_status,
        'first_detected': value.first_detected,
        'created': value.created,
        'updated': value.updated,
        'blocklists': value.blocklists === undefined ? undefined : ((value.blocklists as Array<any>).map(ControlEntityAssetDomainBlocklistToJSON)),
        'findings_count': value.findings_count,
        'max_level': ControlFindingsLevelToJSON(value.max_level),
    };
}

